import { Box, Typography } from "@mui/joy";
import { DocumentPreviewWidget, DocumentUploadWidget } from "../../../../components";

export function Documentation() {
    const documents = [
        {
            title: "EagleView Report",
            description: "EagleView report for the project",
            fileType: "PDF",
        },
        {
            title: "Client Approval Form",
            description: "Form signed by the homeowner approving project scope",
            fileType: "PDF",
        },
        {
            title: "Material Specs Sheet",
            description: "Specifications for composite shingles to be used",
            fileType: "XLSX",
        },
        {
            title: "Inspection Report",
            description: "Detailed site inspection report before teardown",
            fileType: "PDF",
        },
        {
            title: "Contract Agreement",
            description: "Signed agreement between contractor and client",
            fileType: "DOCX",
        },
        {
            title: "Permit Document",
            description: "City-issued building permit for roof replacement",
            fileType: "PDF",
        },
        {
            title: "Safety Guidelines",
            description: "Updated safety procedures for roofing crew",
            fileType: "DOCX",
        },
        {
            title: "Photo Evidence",
            description: "Before and after images for insurance documentation",
            fileType: "JPG",
        },
        {
            title: "Estimate Breakdown",
            description: "Cost estimate including labor and materials",
            fileType: "XLSX",
        },
        {
            title: "Invoice #2049",
            description: "Final billing invoice sent to homeowner",
            fileType: "PDF",
        },
        {
            title: "Warranty Terms",
            description: "Coverage terms for roofing materials and labor",
            fileType: "PDF",
        },
    ];

    return (
        <Box ml={3} mt={1}>
            <Typography level="title-md">Jump back in ({documents.length}) </Typography>
            <Box display="flex" flexWrap="wrap" gap={4} mt={2}>
                {/* <Box mr={1}>
                    <DocumentUploadWidget title="Upload" description="Upload any new document" backgroundLayer={true} />
                </Box> */}

                {documents.map((doc, index) => (
                    <DocumentPreviewWidget
                        key={index}
                        title={doc.title}
                        description={doc.description}
                        fileType={doc.fileType}
                    />
                ))}
            </Box>
        </Box>
    );
}
